<template>
  <div class="bb-contact-percent">
    <input
      class="bb-contact-percent__input bb-input bb-input_border"
      type="number"
      :value="value"
      @input="onChangeInput($event)"
    />
    <span class="bb-contact-percent__text">
      %
    </span>
  </div>
</template>

<script>
export default {
  name: 'ContactFormPercent',
  props: {
    client: {
      type: Object,
      default: () => ({})
    },
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    prop: {
      type: String,
      default: ''
    }
  },
  computed: {
    value: {
      get () {
        return this.client[this.prop]
      },
      set (data) {
        this.$set(this.client, this.prop, data)
      }
    }
  },
  methods: {
    minMaxInput (newVal) {
      if (Number(newVal) > this.max) {
        this.value = this.max
      } else if (Number(newVal) < this.min) {
        this.value = this.min
      }
    },
    onChangeInput ({ target }) {
      const { value } = target
      this.value = Number(value)
      this.minMaxInput(value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";

  .bb-contact-percent {
    width: 100%;
    position: relative;

    &__input {
      width: 70px;
      padding: 8px 20px 8px 10px;
      font-size: 12px;
    }

    &__text {
      position: absolute;
      font-size: 13px;
      font-weight: 400;
      color: $color-gray;
      transform: translateY(-50%);
      top: 50%;
      left: 49px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactForm/ContactFormPercent.vue